<template>
  <v-container class="my-5 px-12 elevation-3 rounded-md">
    <div class="">
      <p class="mb-0">DWS-USOR 92</p>
      <p class="mb-0">Rev. 09/2019</p>
      <img src="" alt="">
    </div>
    <div class="text-center mb-8">
      <p class="mb-0">State of Utah</p>
      <p class="mb-0">Department of Workforce Services</p>
      <h4 class="font-weight-bold">INITIAL JOB PLACEMENT ASSESSMENT</h4>
    </div>
    <div class="text-justify">
      <p>
        This document should be completed after the client completes the 5 th work day. The information will
        serve as a resource to determine additional interventions and authorization for additional job coaching
        hours. This form must be submitted with the job placement milestone bill after the 5 th shift along with
        the employer verification form.
      </p>
    </div>
    <v-form>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field 
            label="Client Name:"
            v-model="initJPAssessment.infos.clientName"
            required
            :rules="initJPAssessment.infos.rules.name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field 
            label="VR Counselor:"
            v-model="initJPAssessment.infos.vrCounselor"
            required
            :rules="initJPAssessment.infos.rules.name"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="7">
          <v-text-field 
            label="CRP:"
            v-model="initJPAssessment.infos.crp"
            required
            :rules="initJPAssessment.infos.rules.name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="5">
          <v-menu
            v-model="initJPAssessment.infos.menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="initJPAssessment.infos.date"
                label="Date:"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="initJPAssessment.infos.date"
              @input="initJPAssessment.infos.menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field 
            label="Employeer:" 
            v-model="initJPAssessment.infos.employeer"
            required
            :rules="initJPAssessment.infos.rules.name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field 
            label="Supervisor:"
            v-model="initJPAssessment.infos.supervisor"
            required
            :rules="initJPAssessment.infos.rules.name"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <v-alert
      color="red lighten-3"
      dense
      class="boder-color-black"
    >
      <strong class="">Worksite Evaluation</strong>
    </v-alert>
    <v-row>
      <v-col cols="12" sm="6">
        <p>Rate the following questions on a scale of 1-10: </p>
      </v-col>
      <v-col cols="12" sm="3">
        <p class="text-center"><strong>1</strong> - Never</p>
      </v-col>
      <v-col cols="12" sm="3">
        <p class="text-center"><strong>10</strong> - Always</p>
      </v-col>
    </v-row>
    <v-simple-table class="mb-5">
      <template v-slot:default overflow-x-auto>
        <thead>
        <tr>
          <th class="text-left"></th>
          <th v-for="rate in 10" :key="rate">{{rate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <p>
              <strong>Attendance:</strong> The employee/client arrives and leaves on time and maintains proper attendance.
            </p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.worksiteEval.attendance">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Time Management:</strong> The employee/client takes meals and breaks appropriately.
            </p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.worksiteEval.timeManagement">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Appearance:</strong> The employee/client’s grooming and hygiene are appropriate for the workplace
            </p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.worksiteEval.appearance">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Communication:</strong> The employee/client uses appropriate communication skills.
            </p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.worksiteEval.communication">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Job Task Completion Rate:</strong> The employee/ client’s performance is comparable to that of coworkers.
            </p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.worksiteEval.jobTaskCompletion">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Job Task Quality:</strong> The employee/client’s work product meets the employer’s standards.
            </p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.worksiteEval.jobTaskQuality">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="mx-2">
      <p>Overall appraisal of the employee/client’s performance:</p>
      <v-textarea outlined v-model="initJPAssessment.worksiteEval.overallAppraisal"></v-textarea>
      <p>List any problems experienced by the employee/client:</p>
      <v-textarea outlined v-model="initJPAssessment.worksiteEval.problems"></v-textarea>
    </div>
    <v-alert
      color="red lighten-3"
      dense
      class="boder-color-black"
    >
      <strong>Natural Support Evaluation</strong>
    </v-alert>
    <p class="mb-0">Recommendations:</p>
    <ul class="ml-5 mb-4">
      <li>Get reports from natural supports regarding progress on the job</li>
      <li>Identify transportation issues</li>
      <li>Discuss behavior at the home and interventions</li>
      <li>Talk with Parents/group home counselor about any problems perceived</li>
      <li>Observe how client interacts with natural supports</li>
    </ul>
    <v-row>
      <v-col cols="12" sm="6">
        <p>Rate the following questions on a scale of 1-10: </p>
      </v-col>
      <v-col cols="12" sm="3">
        <p class="text-center"><strong>1</strong> - Never</p>
      </v-col>
      <v-col cols="12" sm="3">
        <p class="text-center"><strong>10</strong> - Always</p>
      </v-col>
    </v-row>
    <v-simple-table class="mb-5">
      <template v-slot:default overflow-x-auto>
        <thead>
        <tr>
          <th class="text-left"></th>
          <th v-for="rate in 10" :key="rate">{{rate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <p>Does the client enjoy the job?</p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.naturalSupEval.enjoy">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>Does the client have difficulty getting ready for the job?</p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.naturalSupEval.difficulty">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>Is the client motivated to earn money in the job?</p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.naturalSupEval.motivated">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>Is the client careful to maintain neat appearance when reporting to work?</p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.naturalSupEval.neatAppearance">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>Does the client behave appropriately when outside the home?
            </p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.naturalSupEval.behave">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>Does the client complain about the job?</p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.naturalSupEval.complain">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>Is transportation to and from work a problem for the client?</p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.naturalSupEval.transpoProb">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <p>Does the client speak positively about the job with supervisors and co-workers?</p>
          </td>
          <td v-for="rate in 10" :key="rate">
            <v-radio-group v-model="initJPAssessment.naturalSupEval.speak">
              <v-radio :value="rate"></v-radio>
            </v-radio-group>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="mx-2 mb-0">
      <p>Is the client worried that he or she will lose the job for some reason?</p>
      <v-textarea outlined v-model="initJPAssessment.naturalSupEval.worry"></v-textarea>
      <p>Does the client’s family have any concerns about the new job?</p>
      <v-textarea outlined v-model="initJPAssessment.naturalSupEval.concerns"></v-textarea>
    </div>
    <p>I understand that I am electronically signing this form, and I certify that the information on this form is correct to the best of my knowledge.</p>
    <v-row>
      <v-col cols="12" md="7">
        <v-file-input
          v-model="initJPAssessment.crpSignature.signature"
          :rules="initJPAssessment.crpSignature.rules"
          accept="image/*"
          label="CRP Signature: "
          required
        ></v-file-input>
      </v-col>
      <v-col cols="12" md="5">
        <v-menu
          v-model="initJPAssessment.crpSignature.menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="initJPAssessment.crpSignature.dateSigned"
              label="Date:"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="initJPAssessment.crpSignature.dateSigned"
            @input="initJPAssessment.crpSignature.menu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-container class="d-flex justify-end pt-0">
      <v-btn depressed elevation="3" @click="savedAssess">
        Submit
      </v-btn>
    </v-container>
    <div class="text-center">
      <h6 class="font-italic">Equal Opportunity Employer/Program</h6>
      <p class="caption mb-0">
        Auxiliary aids and services are available upon request to individuals with disabilities by calling 801-526-9240. Individuals
      </p>
      <p class="caption mb-0">
        who are deaf, hard of hearing, or have speech impairments may call Relay Utah by dialing 711. Spanish Relay Utah: 1-888-346-3162.
      </p>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      initJPAssessment: {
        id: null,
        /* Information */
        infos: {
          rules: {
            name: [val => (val || '').length > 0 || 'This field is required'],
          },
          clientName: '',
          vrCounselor: '',
          crp: '',
          employeer: '',
          supervisor: '',
          date: moment(new Date()).format("YYYY-MM-DD"),
          // vuetify date-picker template --------------------------------------------------------------------
          menu: false,
          modal: false,
          // -------------------------------------------------------------------------------------------------
        },

        /* Worksite Evaluation */
        worksiteEval: {
          attendance: null,
          timeManagement: null,
          appearance: null,
          communication: null,
          jobTaskCompletion: null,
          jobTaskQuality: null,

          overallAppraisal: '',
          problems: '',
        },

        /* Natural Support Evaluation */
        naturalSupEval: {
          enjoy: null,
          difficulty: null,
          motivated: null,
          neatAppearance: null,
          behave: null,
          complain: null,
          transpoProb: null,
          speak: null,

          worry: '',
          concerns: '',
        },

        /* CRP Signature */
        crpSignature: {
          signature: null,
          rules: [
            value => !value || value.size < 5000000 || 'image size should be less than 5 MB!',
          ],
          dateSigned: moment(new Date()).format("YYYY-MM-DD"),
          // vuetify date-picker template -------------------------------------------------------------------- 
          menu: false,
          modal: false,
          // -------------------------------------------------------------------------------------------------
        }
      },

      assessment: [],
    }
  },
  methods: {
    savedAssess() {
      /* Save the logs in array */
      this.assessment.push(this.initJPAssessment);
    }
  },
}
</script>